export const SE_PERSONA_PICKER_NAV_TREE = {
  label: 'SePersonaPicker', secondaryItems: [
    {
      label: 'SePersonaPicker',
      key: 'se-persona-picker',
      attributes: { href: '/docs/se-persona-picker/overview' }
    },
    {
      label: 'Feature Add Guardian Modal',
      key: 'feature-add-guardian-modal',
      attributes: { href: '/docs/se-persona-picker/feature-add-guardian-modal'}
    }
  ]
}
